import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getLoadingDictTreeApi, getLoadingCalendarApi, getLoadingByDateApi, postLoadingDataApi } from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    LoadingData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    id: '',
    save: false,
}

/* 获取日历上的数据 */
export const getLoadingDataCalendarAction = createAsyncThunk('LoadingDataSlice/getLoadingDataCalendarAction', async (params, thunkAPI) => {
    try {
        const result = await getLoadingCalendarApi(params)
        return result?.data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 获取数据字典*/
export const getLoadingDataDictDataAction = createAsyncThunk('LoadingDataSlice/getLoadingDataDictDataAction', async (dictType, thunkAPI) => {
    const nameDataDict = getLoadingDictTreeApi(dictType[0])
    return Promise.all([nameDataDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 获取数据 */
export const getLoadingDataDataAction = createAsyncThunk('LoadingDataSlice/getLoadingDataDataAction', async (listDataParams, thunkAPI) => {
    try {
        const data = await getLoadingByDateApi(listDataParams)
        return data?.data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 保存数据 */
export const postLoadingDataDataAction = createAsyncThunk('LoadingDataSlice/postLoadingDataDataAction', async (mmoObj, { dispatch }) => {
    try {
        await postLoadingDataApi(mmoObj)
        return true // 已保存状态
    } catch (error) {
        dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 通过日期获取 id */
export const getLoadingByDateAction = createAsyncThunk('LoadingSlice/getLoadingByDateAction', async (listDataParams, thunkAPI) => {
    try {
        const commentData = await getLoadingByDateApi(listDataParams) // 通过日期查询 id
        return commentData?.data?.data?.id
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
}
)

export const LoadingSlice = createSlice({
    name: 'LoadingSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.LoadingData = null
            state.calendarData = null
            state.save = false
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getLoadingDataCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getLoadingDataDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        // /* 通过日期，获取 回显数据 */
        [getLoadingDataDataAction.fulfilled.type]: (state, action) => {
            state.LoadingData = action.payload
            state.id = action.payload?.data?.id
        },

        /* 通过日期，获取 id */
        [getLoadingByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
